<template>
  <div class="carousel">
    <div class="carousel__inner">
      <hooper
        :itemsToShow="isMobileWidth ? 1 : 1.45"
        :centerMode="true"
        :autoPlay="true"
        :playSpeed="5000"
        :pagination="true"
        :infiniteScroll="true"
      >
        <slide v-for="(slide, i) in imgList" :key="i">
          <a :href="slide.link">
            <img
              :src="slide.src"
              :alt="slide.alt"
            />
          </a>
        </slide>
        <hooper-navigation slot="hooper-addons" />
        <hooper-pagination
          slot="hooper-addons"
          class="carousel__control"
        ></hooper-pagination>
      </hooper>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";

export default {
  name: "OrganismsTopCarouselBanner",
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  props:{
    imgList: {
      type: Array,
      default: () => []
      
    }
  },
  computed: {
    isMobileWidth() {
      return window.innerWidth < 570;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/css/organisms/top/carouselBanner.scss";
</style>
